<template>
  <img src="https://myflow.fra1.digitaloceanspaces.com/purp.svg" />
</template>